module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_08.90f461c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_08.png
// module id = tSXH
// module chunks = 1